import { DatePicker } from 'antd';
import React from 'react';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment';

export interface RealTimeParamsPropies {
    value?: number;
    onChange?: (value: number) => void;
    disabled?: boolean;
    typeName?: string
}

export default function RealTimeDataPicker(props: RealTimeParamsPropies) {
    const onOk = (value: any) => {
        props.onChange?.(value.valueOf() ??new Date().valueOf() )
      };
    return <DatePicker
        value={moment(props.value)}
        onOk={onOk}
        onChange={(date) =>{
            props.onChange?.(date?.valueOf() ??props.typeName ==='开始时间' ?new Date().valueOf():new Date().valueOf()+ 3600000 )
        }}
        disabled={props.disabled}
        showTime
        locale={locale}
        style={{ width: '100%' }}
    />
}